module.exports = __webpack_public_path__ + "static/media/slider_6_collab_user_es.f22a5df6.svg";